// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"4941b2c2","222":"eea50b02","389":"bf63b576","991":"9e71f789"}[chunkId] + ".chunk.js";
};